<template>
  <v-app>
    <v-app-bar app class="d-print-none">
      <v-toolbar-title class="headline text-uppercase">
        ONJUISTE DECLARATIES
        <span class="font-weight-light">MEDICOM</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: "App"
};
</script>

<style lang="scss" scoped>
.v-app-bar {
  a {
    color: rgba(0, 0, 0, 0.87);
    text-decoration: none;
  }
}
</style>
